import {FC} from 'react';

import Users from '../../components/Users';

import styles from './Users.module.scss';

const UsersPage: FC = () => {
  return (
    <div className={styles.employees}>
      <Users />
    </div>
  );
};

export default UsersPage;
